import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { useIsAuthenticated } from '@zapier/design-system-revenue/src/hooks';

import { shouldRenderTeamTrialBanner as ShouldRenderTeamTrialBannerQuery } from './types/shouldRenderTeamTrialBanner';

export const shouldRenderTeamTrialBannerQuery = gql`
  query shouldRenderTeamTrialBanner($accountId: Int!) {
    account(id: $accountId) {
      id
      isTrialingTeams
    }
  }
`;

export type Props = {
  skip?: boolean;
};

export const useShouldRender = ({ skip }: Props = {}) => {
  const { isAuthenticated } = useIsAuthenticated();

  const accountId = localStorage.getItem('currentAccountId');

  const { data } = useQuery<ShouldRenderTeamTrialBannerQuery>(
    shouldRenderTeamTrialBannerQuery,
    {
      skip: skip || !isAuthenticated || !accountId,
      variables: {
        accountId: parseInt(accountId ?? ''),
      },
    }
  );

  return Boolean(data?.account?.isTrialingTeams);
};
